import * as type from './mutation-types'
export const state = {
    status: -9999,
    errmsg: '',
    userInfo: {},
    loading: 'loading',
    serverList: {},
    loadingSL: 'loadingSL',
    roleList: {},
    loadingRL: 'loadingRL',
    areaList: {},
    loadingAL: 'loadingAL',
    switchInfo: {},
    switching: 'switching',
    uname: '',
    uid: '',
    deviceId: '',
    appid: '',
    clientPlat: '',
    phoneModel: '',
    channelId: '',
    token: '',
    cpUid: '',
    lang: '',
    roleName: '',
    serverName: '',
    areaId: '',
    serverId: '',
    roleId: '',
    sdkVersion: '',
    apkVersion: '',
    loginTypes: '',
    isNewUploadLog: '',
    uniqueId: '',
    showPage: false
}
export function getCookiesObj() { 
    return document.cookie.split(';').reduce((f, sv) => {
        let _sv = sv.trim().split('=').map(v => {
            return v.trim()
        })
        f[_sv[0]] = _sv[1]   
        return f  
    }, {})
}
export const mutations = {
    [type.ERROR_RECEIVE](state, res) {},
    [type.INIT](state, res) {
        res.uname && (state.uname = res.uname)
        res.uid && (state.uid = res.uid)
        res.deviceId && (state.deviceId = res.deviceId)
        res.appId && (state.appid = res.appId)
        res.clientPlat && (state.clientPlat = res.clientPlat)
        res.phoneModel && (state.phoneModel = res.phoneModel)
        res.channelId && (state.channelId = res.channelId)
        res.token && (state.token = res.token)
        res.cpUid && (state.cpUid = res.cpUid)
        res.lang && (state.lang = res.lang)
        res.roleName && (state.roleName = res.roleName)
        res.serverName && (state.serverName = res.serverName)
        res.areaId && (state.areaId = res.areaId)
        res.serverId && (state.serverId = res.serverId)
        res.roleId && (state.roleId = res.roleId)
        res.sdkVersion && (state.sdkVersion = res.sdkVersion)
        res.apkVersion && (state.apkVersion = res.apkVersion)
        res.loginTypes && (state.loginTypes = res.loginTypes)
        res.isNewUploadLog && (state.isNewUploadLog = res.isNewUploadLog)
        res.uniqueId && (state.uniqueId = res.uniqueId)
        res.showPage && (state.showPage = res.showPage)
    },
    [type.GETUSERINFO_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.userInfo = {}
        state.loading = 'loading'
    },
    [type.GETUSERINFO_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.userInfo = (res && res.content) || {}
        state.loading = state.status > -9999 && 'loaded'
    },
    [type.GETSERVERLIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.serverList = {}
        state.loadingSL = 'loadingSL'
    },
    [type.GETSERVERLIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.serverList = (res && res.content) || {}
        state.loadingSL = state.status > -9999 && 'loadedSL'
    },
    [type.GETGAMEROLELIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.roleList = {}
        state.loadingRL = 'loadingRL'
    },
    [type.GETGAMEROLELIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.roleList = (res && res.content) || {}
        state.loadingRL = state.status > -9999 && 'loadedRL'
    },
    [type.GETAREALIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.areaList = {}
        state.loadingAL = 'loadingAL'
    },
    [type.GETAREALIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.areaList = (res && res.content) || {}
        state.loadingAL = state.status > -9999 && 'loadedAL'
    },
    [type.GETSWITCHINFO_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.switchInfo = {}
        state.switching = 'switching'
    },
    [type.GETSWITCHINFO_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.switchInfo = (res && res.content) || {}
        state.switching = state.status > -9999 && 'switched'
    }
}